import { render, staticRenderFns } from "./wareDetailModule.vue?vue&type=template&id=01cdfc52&scoped=true&"
import script from "./wareDetailModule.vue?vue&type=script&lang=js&"
export * from "./wareDetailModule.vue?vue&type=script&lang=js&"
import style0 from "./wareDetailModule.vue?vue&type=style&index=0&id=01cdfc52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cdfc52",
  null
  
)

export default component.exports